import { useFieldArray, useForm } from 'react-hook-form';

interface FormValues {
  planFields: { id: string; selected: boolean }[];
}

export interface ComparePlansProps {
  data: {
    plans: { id: string; name: string }[];
    selectedPlans: string[];
  };
  onSave(selectedPlans: string[]): void;
  onClose(): void;
}

export const useComparePlans = ({
  data: { plans, selectedPlans },
  onSave,
  onClose,
}: ComparePlansProps) => {
  const formBag = useForm<FormValues>({
    defaultValues: {
      planFields: plans.map(plan => ({
        id: plan.id,
        selected: selectedPlans.includes(plan.id),
      })),
    },
  });
  const { fields } = useFieldArray({
    control: formBag.control,
    name: 'planFields',
    keyName: 'key',
  });
  const watchFieldArray = formBag.watch('planFields');
  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  const selectedPlansCount = controlledFields.filter(field => field.selected).length;

  const onSubmit = formBag.handleSubmit((values: FormValues) => {
    const newSelectedPlans = values.planFields
      .filter(field => field.selected)
      .map(field => field.id);

    onSave(newSelectedPlans);
    onClose();
  });

  return {
    ...formBag,
    fields: controlledFields,
    selectedPlansCount,
    onSubmit,
  };
};
